import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import CounterLogin from "@/pages/CounterLogin";
import CounterHome from "@/pages/CounterHome";
import CountFlow from "@/pages/CountFlow";
import AdminApp from "@/pages/admin/AdminApp";

function Protected({ roles, children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-[color:var(--muted)]">Loading…</div>;
  if (!user) return <Navigate to="/" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/counter" element={<CounterLogin />} />
          <Route path="/count" element={<Protected roles={["counter"]}><CounterHome /></Protected>} />
          <Route path="/count/:sessionId" element={<Protected roles={["counter"]}><CountFlow /></Protected>} />
          <Route path="/admin/*" element={<Protected roles={["admin", "auditor", "coordinator", "superadmin"]}><AdminApp /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
